import styled from "styled-components";

export const CardWrapper = styled.div`
  padding: 16px 20px;
  border-radius: 12px;
  display: flex;
  align-items: start;
  gap: 16px;
  cursor: pointer;
  border: 1px solid var(--hv-border-default);
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg path{
    stroke: var(--hv-icon-normal-secondary);
  }
  
}
`;

export const CardText = styled.div`
  flex: 1;
  font-weight: 400;
  font-size: 14px;
  h3 {
    margin-bottom: 4px;
    color: var(--text-primary);
    line-height: 20px;
  }

  p {
    color: var(--text-secondary-2);
    line-height: 18px;
  }
`;
